export var CustomCarrierCodes;
(function (CustomCarrierCodes) {
    CustomCarrierCodes["jtiPickup"] = "jti_pickup";
})(CustomCarrierCodes || (CustomCarrierCodes = {}));
//# sourceMappingURL=custom-carrier.js.map